export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: 'ce2b137', dateTime: 1775523341994 };